import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { EnvironmentService } from "./environment.service";
import { PaginationRequest } from "./models/pagination/pagination.request.model";
import { RequestHelper } from "@shared/helpers/request.helper";
import { Observable } from "rxjs";

@Injectable({ providedIn: 'root' })
export class LeadApiService {
    constructor(
        private httpClient: HttpClient,
        private environmentService: EnvironmentService
    ) {}

    private get url(): string {
        return `${this.environmentService.getCurrentApiUrl()}/leads`;
    }

    getLeads(req: PaginationRequest): Observable<any> {
        const options = RequestHelper.createRequestOption(req);
        return this.httpClient.get<any>(this.url, { params: options });
    }

    /**
     * Search leads with complex filters.
     * Body format: { lead_campaign_id?, textSearch?, gender?, interested_course?, birthday?: { from?, to? }, createdAt?: { from? } }
     */
    searchLeads(req: PaginationRequest, body: any): Observable<any> {
        const options = RequestHelper.createRequestOption(req);
        return this.httpClient.post<any>(`${this.url}/search`, body || {}, { params: options });
    }

    createLead(lead: any): Observable<any> {
        return this.httpClient.post<any>(this.url, lead);
    }

    updateLead(lead: any): Observable<any> {
        return this.httpClient.put<any>(this.url, lead);
    }

    deleteLead(id: string): Observable<any> {
        return this.httpClient.delete<any>(`${this.url}/${id}`);
    }

    getLeadById(id: string): Observable<any> {
        return this.httpClient.get<any>(`${this.url}/${id}`);
    }

    importLeads(file: File): Observable<any> {
        const formData = new FormData();
        formData.append('file', file);
        
        // Use observe: 'response' to get full response including headers
        // responseType: 'blob' to handle file download, but we'll check content-type
        return this.httpClient.post(`${this.url}/import`, formData, {
            observe: 'response',
            responseType: 'blob'
        });
    }

    importLeadsWithCampaign(formData: FormData): Observable<any> {
        // Use observe: 'response' to get full response including headers
        // responseType: 'blob' to handle file download, but we'll check content-type
        return this.httpClient.post(`${this.url}/import`, formData, {
            observe: 'response',
            responseType: 'blob'
        });
    }

    downloadTemplate(): Observable<any> {
        return this.httpClient.get(`${this.url}/template/download`, {
            observe: 'response',
            responseType: 'blob'
        });
    }
}